/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';
import { isPxeTocActiveForBook, normalizePxeTocEntries, setPxeAsset } from '../common/PxePreviewUtils';

export default class PxeTocService extends BaseService {
  constructor() {
    super(constants.PXE_TOC_DATA_FETCHED, 'pxeTocStatus');
  }

  handleEvent(eventName, event) {
    if (!event?.bookId) {
      return null;
    }
    return this.getClient('evergreen').get(`books/${event.bookId}/pxe/toc`);
  }

  handleResponse(response, event) {
    const bookDetail = Framework.getStoreRegistry().getStore('booksState')?.bookDetail;
    if (!isPxeTocActiveForBook(bookDetail, event?.authoringBookId, event?.bookId)) {
      return;
    }
    const toc = normalizePxeTocEntries(response?.data?.toc ?? response?.data);
    const asset = Framework.getStoreRegistry().getStore('asset');
    setPxeAsset(asset, event.authoringBookId, event.globalBookId, toc, event.bookBasePath);
  }

  handleError(error, event) {
    const { response } = error || {};
    if (response?.status === 401) {
      utils.redirectToLogin();
      return;
    }
    const bookDetail = Framework.getStoreRegistry().getStore('booksState')?.bookDetail;
    if (!isPxeTocActiveForBook(bookDetail, event?.authoringBookId, event?.bookId)) {
      return;
    }
    if (event?.authoringBookId) {
      const asset = Framework.getStoreRegistry().getStore('asset');
      setPxeAsset(asset, event.authoringBookId, event.globalBookId, [], event.bookBasePath);
    }
  }
}
